import Layout, { Content, Footer, Header } from 'antd/lib/layout/layout';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { PageType } from '../../model/types';
import HeaderComponent from '../HeaderComponent/HeaderComponent';
import MenuComponent from '../MenuComponent/MenuComponent';
import styles from './LayoutComponent.module.scss';
import { Alert } from 'antd';
import CustomContext from '../../context/CustomContext';
import { useContext } from 'react';

/**
 * Returns the layout component.
 * @param props the props
 * @returns the layout component
 */
const LayoutComponent = (props: Props): React.ReactElement => {
    const { children, pageId, style } = props;

    /*** HOOKS ***/

    const context = useContext(CustomContext);
    const { providerAuths } = context;

    /*** COMPONENTS */

    return (
        <Layout
            className={styles.layout}
            style={pageId && ['home', 'error', 'loginError', 'loading'].includes(pageId) ? style : undefined}
        >
            <Header className={styles.header}>
                <HeaderComponent />
            </Header>
            {pageId === 'home' && providerAuths.length === 0 && (
                <Alert message={<FormattedMessage id="home.warningProviders" />} banner closable type="info" />
            )}
            <Layout hasSider>
                <MenuComponent pageId={pageId} />
                <Content className={styles.content} style={style}>
                    {children}
                </Content>
            </Layout>
            <Footer className={styles.footer}>
                <div className={styles.links}>
                    <a href="/" target="_blank" rel="noreferrer">
                        <FormattedMessage id="footer.help" />
                    </a>
                </div>
                <a href="https://www.modelical.com">© Modelical</a>
            </Footer>
        </Layout>
    );
};

export default LayoutComponent;

interface Props {
    pageId?: PageType;
    style?: React.CSSProperties;
    children: React.ReactNode;
}
